import Action from './action';
import { equar } from '../../../utils/common';

const initialState = {
    mailPaymentOrder: [],
    errorTexts: []
}

export default (state = initialState, action: {type: string, playload: string[] | number}) => {
    switch (action.type) {
        case Action.UPDATE_MAIL_PAYMENT_ORDER: {
            return {
                ...state,
                mailPaymentOrder: action.playload
            }
        }
        case Action.UPDATE_MAIL_PAYMENT_ORDER_ERROR_TEXT: {
            try {
                const newErrors = (action.playload as string[] || []).filter(Boolean);
                const curErrors = state.errorTexts.filter(Boolean);
                if (!equar(newErrors, curErrors) && newErrors.length >= curErrors.length) {
                    (window as any).mailStats.show('mail_payment_order_error', { errorText: action.playload })
                }
            } catch(e) {}
            return {
                ...state,
                errorTexts: action.playload
            }
        }
        case Action.UPDATE_MAIL_PAYMENT_ORDER_ERROR_TEXT_BY_INDEX: {
            state.errorTexts.splice(action.playload as number, 1);
            return {
                ...state,
                errorTexts: [...state.errorTexts]
            }
        }
        default: return state;
    }
}
